var _path, _g, _path2, _path3, _path4, _path5, _g2, _path6, _path7, _path8, _path9, _g3, _path0, _path1, _path10, _path11, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyCategory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 212,
    height: 150,
    fill: "none",
    viewBox: "0 0 212 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M172.984 0H44.742C38.84 0 34.055 4.785 34.055 10.687v128.242c0 5.902 4.785 10.687 10.687 10.687h128.242c5.902 0 10.687-4.785 10.687-10.687V10.687C183.671 4.785 178.886 0 172.984 0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M154.98 9.644H11.32c-2.938 0-5.32 2.364-5.32 5.28V41.33c0 2.917 2.382 5.282 5.32 5.282h143.66c2.939 0 5.321-2.365 5.321-5.282V14.925c0-2.917-2.382-5.281-5.321-5.281"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#BED000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m147.543 27.065 3.181 3.18 3.18-3.18",
    opacity: 0.5
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#BED000",
    fillOpacity: 0.5,
    d: "M79.426 18.094H51.758c-1.763 0-3.192 1.418-3.192 3.168s1.429 3.17 3.192 3.17h27.668c1.763 0 3.192-1.42 3.192-3.17s-1.43-3.168-3.192-3.168"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F6CC",
    d: "M98.58 31.825H51.758c-1.763 0-3.193 1.419-3.193 3.169s1.43 3.169 3.193 3.169H98.58c1.763 0 3.193-1.42 3.193-3.17s-1.43-3.168-3.193-3.168"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#BED000",
    d: "M39.135 12.813H15.431c-3.446 0-6.239 2.364-6.239 5.28v20.069c0 2.917 2.793 5.281 6.239 5.281h23.704c3.445 0 6.238-2.364 6.238-5.281V18.094c0-2.917-2.793-5.282-6.238-5.282"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M20.489 37.264q-1.02 0-1.716-.69-.695-.69-.695-1.703V21.384q0-1.012.695-1.703.696-.69 1.716-.69h13.588q1.02 0 1.715.69t.696 1.703v13.487q0 1.013-.696 1.703-.695.69-1.715.69zm0-1.743h13.588a.63.63 0 0 0 .45-.203.62.62 0 0 0 .205-.447V21.384a.62.62 0 0 0-.205-.447.63.63 0 0 0-.45-.203H20.489a.63.63 0 0 0-.45.203.62.62 0 0 0-.205.447v13.487a.62.62 0 0 0 .204.447.63.63 0 0 0 .45.203m2.732-2.218h8.288q.39 0 .536-.322a.61.61 0 0 0-.06-.625l-2.228-2.998a.55.55 0 0 0-.477-.236.62.62 0 0 0-.477.263l-2.36 2.955-1.438-1.69a.58.58 0 0 0-.464-.23q-.277 0-.469.25l-1.308 1.686q-.224.303-.08.625.146.322.537.322m.337-7.473q.585 0 .997-.41t.413-.99-.413-.989a1.36 1.36 0 0 0-.997-.41q-.583 0-.997.41a1.34 1.34 0 0 0-.413.99q0 .579.413.99.414.41.997.41"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M200.679 56.256H57.019c-2.938 0-5.32 2.364-5.32 5.281v26.406c0 2.916 2.382 5.28 5.32 5.28h143.66c2.939 0 5.321-2.364 5.321-5.28V61.537c0-2.917-2.382-5.281-5.321-5.281"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#BED000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m193.87 73.522 3.206 3.206 3.206-3.206",
    opacity: 0.5
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#BED000",
    fillOpacity: 0.5,
    d: "M125.475 64.439H97.689a3.206 3.206 0 1 0 0 6.412h27.786a3.206 3.206 0 0 0 0-6.412"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F6CC",
    d: "M144.711 78.331H97.689a3.206 3.206 0 1 0 0 6.412h47.022a3.206 3.206 0 1 0 0-6.412"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#BED000",
    d: "M85.012 59.094H61.206c-3.46 0-6.265 2.392-6.265 5.343v20.305c0 2.951 2.805 5.344 6.265 5.344h23.806c3.46 0 6.265-2.393 6.265-5.344V64.437c0-2.95-2.805-5.343-6.265-5.343"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M66.286 83.835q-1.024 0-1.723-.698-.698-.699-.698-1.723V67.768q0-1.025.698-1.723.699-.698 1.723-.698h13.646q1.024 0 1.723.698.698.698.698 1.723v13.646q0 1.024-.698 1.723-.699.698-1.723.698zm0-1.763h13.646a.63.63 0 0 0 .452-.206.63.63 0 0 0 .206-.452V67.768a.63.63 0 0 0-.206-.453.63.63 0 0 0-.452-.205H66.286a.63.63 0 0 0-.452.206.63.63 0 0 0-.206.452v13.646q0 .246.206.452a.63.63 0 0 0 .452.206m2.743-2.245h8.324q.393 0 .538-.325a.62.62 0 0 0-.06-.632l-2.237-3.034q-.194-.252-.48-.24a.62.62 0 0 0-.478.267l-2.37 2.99-1.444-1.71a.58.58 0 0 0-.467-.232q-.278 0-.47.253L68.57 78.87q-.225.305-.08.632.146.325.538.325m.34-7.56q.585 0 1-.415t.416-1.002q0-.585-.415-1a1.36 1.36 0 0 0-1.001-.416q-.587 0-1.002.415-.414.415-.414 1.001 0 .587.414 1.002.415.414 1.002.414"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M154.98 102.867H11.32c-2.938 0-5.32 2.365-5.32 5.281v26.406c0 2.917 2.382 5.281 5.32 5.281h143.66c2.939 0 5.321-2.364 5.321-5.281v-26.406c0-2.916-2.382-5.281-5.321-5.281"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#BED000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m147.543 120.289 3.181 3.181 3.18-3.181",
    opacity: 0.5
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#BED000",
    fillOpacity: 0.5,
    d: "M79.426 111.317H51.758c-1.763 0-3.192 1.419-3.192 3.169s1.429 3.169 3.192 3.169h27.668c1.763 0 3.192-1.419 3.192-3.169s-1.43-3.169-3.192-3.169"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F6CC",
    d: "M98.58 125.049H51.758c-1.763 0-3.193 1.418-3.193 3.169 0 1.75 1.43 3.168 3.193 3.168H98.58c1.763 0 3.193-1.418 3.193-3.168s-1.43-3.169-3.193-3.169"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#BED000",
    d: "M39.135 106.036H15.431c-3.446 0-6.239 2.365-6.239 5.281v20.069c0 2.916 2.793 5.281 6.239 5.281h23.704c3.445 0 6.238-2.365 6.238-5.281v-20.069c0-2.916-2.793-5.281-6.238-5.281"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M20.489 130.488q-1.02 0-1.716-.691-.695-.69-.695-1.702v-13.487q0-1.013.695-1.703.696-.69 1.716-.69h13.588q1.02 0 1.715.69t.696 1.703v13.487q0 1.012-.696 1.702-.695.691-1.715.691zm0-1.743h13.588a.63.63 0 0 0 .45-.203.62.62 0 0 0 .205-.447v-13.487a.62.62 0 0 0-.205-.447.63.63 0 0 0-.45-.203H20.489a.63.63 0 0 0-.45.203.62.62 0 0 0-.205.447v13.487q0 .243.204.447a.63.63 0 0 0 .45.203m2.732-2.218h8.288q.39 0 .536-.322a.61.61 0 0 0-.06-.625l-2.228-2.998a.55.55 0 0 0-.477-.237.62.62 0 0 0-.477.264l-2.36 2.955-1.438-1.69a.58.58 0 0 0-.464-.23q-.277 0-.469.25l-1.308 1.686q-.224.303-.08.625.146.322.537.322m.337-7.473q.585 0 .997-.41t.413-.99-.413-.989a1.37 1.37 0 0 0-.997-.41q-.583 0-.997.41a1.34 1.34 0 0 0-.413.989q0 .58.413.99.414.41.997.41"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: 166.301,
    height: 48.968,
    x: 0,
    y: 6.644,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow_2549_6469"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2549_6469",
    mode: "normal",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    width: 166.301,
    height: 48.968,
    x: 45.699,
    y: 53.256,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow_2549_6469"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2549_6469",
    mode: "normal",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    width: 166.301,
    height: 48.968,
    x: 0,
    y: 99.867,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow_2549_6469"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2549_6469",
    mode: "normal",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCategory);
export default __webpack_public_path__ + "static/media/empty-category.32800e2dc46fecf5724c43782d10b965.svg";
export { ForwardRef as ReactComponent };